
import {DwollaFundingSourceStates, is_master_account} from "./constants";

const CUSTOMER_MICRODEPOSITS_ADDED = "customer_microdeposits_added";
const CUSTOMER_MICRODEPOSITS_COMPLETED = "customer_microdeposits_completed";
const CUSTOMER_MICRODEPOSITS_MAXATTEMPTS = "customer_microdeposits_maxattempts";


/**
 * Look at all the funding_sources. Find the unverfied source that has
 * microdeposits_added or microdeposits_completed as its last event and
 * return its id.
 *
 * @param dwolla {Object}
 */
const get_microdeposit_payment_id = dwolla => {

  let micro_dep_id;
  Object.keys(dwolla.funding_source).forEach(id => {
    const source = dwolla.funding_source[id];
    if (source.state !== DwollaFundingSourceStates.UNVERIFIED) {
      return false;
    }

    console.log("source events", source.events, "added", CUSTOMER_MICRODEPOSITS_ADDED);
    if (source.events && source.events[CUSTOMER_MICRODEPOSITS_ADDED]) {
      micro_dep_id = id;
    }
  });
  return micro_dep_id;
};

const funding_source_microdeposit_completed = (dwolla, payment_source_id) => {
  return payment_source_id in dwolla.funding_source
    && dwolla.funding_source[payment_source_id].last_event
    && dwolla.funding_source[payment_source_id].last_event.topic === CUSTOMER_MICRODEPOSITS_COMPLETED;
};

const get_microdeposit_too_many_attempts = dwolla => {

  return Object.keys(dwolla.funding_source).find(id => {
    const source = dwolla.funding_source[id];
    if (source.state !== DwollaFundingSourceStates.UNVERIFIED) {
      return false;
    }
    if (!source.last_event) {
      return false;
    }

    return source.last_event.topic === CUSTOMER_MICRODEPOSITS_MAXATTEMPTS;
  })
};

/**
 * Counts the number of payment sources that's not the master account.
 * @param dwolla {obj} dwolla_0000
 */
const count_funding_sources = (dwolla) => {
  const funding_source = dwolla.funding_source;
  if (!funding_source) {
    return 0;
  }
  let count = 0;
  Object.keys(funding_source).forEach(id => {
    const source = funding_source[id];
    if (!is_master_account(source.name)) {
      count++;
    }
  });
  return count;
}

const get_default_funding_source_id = dwolla => {

  let default_id;
  if (count_funding_sources(dwolla) === 1) {
    // Just return the first one
    Object.keys(dwolla.funding_source).forEach(id => {
      //if (dwolla.funding_source[id].name !== TDA_ACCOUNT_NAME) {
      if (!is_master_account(dwolla.funding_source[id].name)) {
        default_id = id;
      }
    });
  } else {
    // Return the default payment source id
    const funding_source = dwolla.funding_source;
    Object.keys(funding_source).forEach(id => {
      if (funding_source[id].default) {
        default_id = id;
      }
    });
  }

  return default_id;

}

export {get_microdeposit_payment_id, get_default_funding_source_id,
  get_microdeposit_too_many_attempts, count_funding_sources,
  funding_source_microdeposit_completed };
